import {
  calculateQuotedPercentForER,
  calculateQuotedPercentForLeg,
} from "./quotedPercentHelpers";

/**
 * AG Grid valueFormatter for copy/paste. Returns the rounded percentage with
 * a trailing space, or empty string when the cell renders blank.
 */
export function quotedPercentValueFormatter(params: any): string {
  if (!params.data) return "";

  const percent = params.data.legs?.length
    ? calculateQuotedPercentForER(params.data.legs)
    : calculateQuotedPercentForLeg(params.data);

  if (percent === null) return "";
  return `${Math.round(percent)} `;
}
